import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractorComponent } from './component/contractor/contractor.component';
import { ContractorContainerComponent } from './container/contractor-container/contractor-container.component';
import { ContractorStaffComponent } from './component/contractor-staff/contractor-staff.component';
import { ReactiveFormsModule } from '@angular/forms';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { StaffregisterRoutingModule } from 'libs/staffregister/src/lib/staffregister-routing-module';
import {ContractorRoutingModule} from './contractor-routing.module'
import { AngularMaterialModule } from '@cradua/material';
import { SpinnersModule } from "@cradua/spinners";
@NgModule({
  imports: [CommonModule, StaffregisterRoutingModule, ReactiveFormsModule,EpimsDashboardNavModule, ContractorRoutingModule, AngularMaterialModule, SpinnersModule],
  declarations: [ContractorContainerComponent, ContractorComponent, ContractorStaffComponent]
})
export class ContractorModule {}
